import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'perfis',
})
export class PerfisPipe implements PipeTransform {
  transform(value: unknown, ...args: unknown[]): unknown {
    return null;
  }
}



@Pipe({
  name: 'formatcpf',
})
export class FormatCpfPipe implements PipeTransform {
  transform(cpf: string): string {

    /*
 * xxx.xxx.xxx-xx (números com pontos e um hifen) ou
 * xxxxxxxxxxx (apenas números)
 */

    return (!cpf || !cpf.match(/^[0-9]{3}.?[0-9]{3}.?[0-9]{3}-?[0-9]{2}/))?
    'NA'
    : cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');



  }
}
